import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-black text-white text-center border-t-8 border-red-600" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <h2 className="text-4xl md:text-5xl font-black mb-6 text-yellow-400" data-id="element-105">
          Tu cuerpo puede cambiar en 30 días
        </h2>

        <p className="text-2xl font-bold mb-2" data-id="element-106">No necesitas otra dieta.</p>
        <p className="text-3xl font-black text-red-500 uppercase tracking-widest mb-8" data-id="element-107">
          Necesitas estructura.
        </p>

        <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-108">
          RESET CORPORAL 30D es un sistema que puedes repetir cada vez que lo
          necesites.
          <br data-id="element-109" />
          <span className="text-white font-bold mt-4 block text-2xl" data-id="element-110">
            Menos inflamación. Más energía. Más control.
          </span>
        </p>

        <CTAButton text="👉 Empieza hoy tu RESET CORPORAL 30D" className="w-full md:w-auto" data-id="element-111" />
      </div>
    </section>;
}